import { Directive, input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { ChangeDependentValidator } from "./changedependentvalidator";

@Directive({
    selector: '[mustEqual]',
    providers: [{ provide: NG_VALIDATORS, useExisting: EqualValidatorDirective, multi: true }],
    standalone: true
})

export class EqualValidatorDirective extends ChangeDependentValidator implements Validator {
    readonly mustEqual = input<any>(undefined);

    constructor() {
        super(['mustEqual']);
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const mustEqual = this.mustEqual();
        if (mustEqual == null || mustEqual == undefined) {
            return null;
        }

        const error: ValidationErrors = control.value != mustEqual
            ? { "mustEqual": `Control value does not equal specified value` }
            : null;
        return error;
    }
}